import { useCallback, useState } from "react";

/**
 * Shared logic for guest "Play" paywall: opens a modal, then dispatches the
 * Google sign-in or Subscribe Now action.  Routing the Google flow through
 * the existing Emergent OAuth redirect keeps a single auth entry point.
 */
export default function usePlayPaywall({ defaultNext = "/audio-comics/books" } = {}) {
  const [open, setOpen] = useState(false);
  const [next, setNext] = useState(defaultNext);

  const promptPaywall = useCallback((nextPath) => {
    setNext(nextPath || defaultNext);
    setOpen(true);
  }, [defaultNext]);

  const close = useCallback(() => setOpen(false), []);

  const goSignIn = useCallback(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    window.location.href = `${API}/api/audio/auth/google/login?next=${encodeURIComponent(next)}`;
  }, [next]);

  const goSubscribe = useCallback(() => {
    // Subscribe always requires login first; route through the login page
    // with subscription as the next destination.
    const target = `/audio-comics/login?next=${encodeURIComponent("/audio-comics/subscription")}`;
    window.location.href = target;
  }, []);

  return { open, promptPaywall, close, goSignIn, goSubscribe };
}
